import { Routes } from '@angular/router';

export const TrainingsRoutes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import('./list/trainings-list.component').then(
				(c) => c.TrainingsListComponent,
			),
	},
	{
		path: ':id',
		loadComponent: () =>
			import('./detail/trainings-detail.component').then(
				(c) => c.TrainingsDetailComponent,
			),
	},
];


export const TrainingsJuhanRoutes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import('./list/trainings-juhan-list.component').then(
				(c) => c.TrainingsJuhanListComponent,
			),
		data: { footerType: 'taiendkoolitus' },
	},
	/*{
		path: 'minu-koolitused',
		loadComponent: () =>
			import('../my-data/my-training-list/my-training-juhan.component').then(
				(c) => c.MyTrainingJuhanComponent,
			),
	},*/
	{
		path: 'juhan-detail/:id',
		loadComponent: () =>
			import('./juhan-mail-redirect/juhan-mail-redirect.component').then(
				(c) => c.TrainingsJuhanMailRedirectComponent,
			),
		data: { type: "detail", footerType: 'taiendkoolitus' }
	},
	{
		path: 'juhan-registration/:id',
		loadComponent: () =>
			import('./juhan-mail-redirect/juhan-mail-redirect.component').then(
				(c) => c.TrainingsJuhanMailRedirectComponent,
			),
		data: { type: "registration", footerType: 'taiendkoolitus' }
	},
	{
		path: 'trainings-juhan-register/:linkId/:id',
		loadComponent: () =>
			import('./register/trainings-juhan-register.component').then(
				(c) => c.TrainingsJuhanRegisterComponent,
			),
		data: { footerType: 'taiendkoolitus' },
	},
	{
		path: 'trainings-juhan-preregister/:linkId/:id',
		loadComponent: () =>
			import('./register/trainings-juhan-preregister.component').then(
				(c) => c.TrainingsJuhanPreRegisterComponent,
			),
		data: { footerType: 'taiendkoolitus' },
	},	
	{
		path: ':linkId/:id',
		loadComponent: () =>
			import('./detail/trainings-juhan-detail.component').then(
				(c) => c.TrainingsJuhanDetailComponent,
			),
		data: { footerType: 'taiendkoolitus' },
	},

];
